// extracted by mini-css-extract-plugin
export var calculatorImage = "TimeAndMaterial-module--calculator-image--18ad3";
export var image = "TimeAndMaterial-module--image--22ff9";